import { render, staticRenderFns } from "./PreAnalysisReason.vue?vue&type=template&id=a2507738&scoped=true"
import script from "./PreAnalysisReason.vue?vue&type=script&lang=js"
export * from "./PreAnalysisReason.vue?vue&type=script&lang=js"
import style0 from "./PreAnalysisReason.vue?vue&type=style&index=0&id=a2507738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2507738",
  null
  
)

export default component.exports